import { useNavigate } from 'react-router-dom'

import { Box, Link, NoticeBox, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { usePermissions } from 'modules/shift_management/hooks/usePermissions'

const WorkplacesLink = () => {
  const { navigation } = useNavigation()

  const navigate = useNavigate()

  return (
    <Link.Touchable
      onClick={() => {
        track('go_to_workplaces', {
          page_referrer: JSON.stringify(navigation.shifts.fullPath()),
        })
        navigate(navigation.settings.locations.fullPath())
      }}
    >
      {i18n.t('time_tracking.timezones_notification.link')}
    </Link.Touchable>
  )
}

const AccessFlashMessage = () => {
  return (
    <Box flexDirection="row" flexWrap="wrap" alignItems="center">
      <Box paddingRight="s8">
        <Text.Normal color="grey1000">
          {i18n.t('shift_management.notices.timezones_notification.description_admin')}
        </Text.Normal>
      </Box>
      <Box>
        <WorkplacesLink />
      </Box>
    </Box>
  )
}

const CommonFlashMessage = () => {
  return (
    <Text.Normal color="grey1000">
      {i18n.t('shift_management.notices.timezones_notification.description')}
    </Text.Normal>
  )
}

const FlashNoticeState = () => {
  const [{ canManageLocation }] = usePermissions()

  return (
    <NoticeBox
      message={canManageLocation ? <AccessFlashMessage /> : <CommonFlashMessage />}
      color="champagne200"
    />
  )
}

export default FlashNoticeState
